import React from 'react';
import { Header3Text } from '../../../../ui-toolkit';
import { Separator } from '../Separator';
import { IStandardDocumentVersionData } from '../../../../types/order/documents/shared/interfaces';
import { GenericEditCreatePolicy } from './GenericEditCreatePolicy';
import { PolicyTypeEnum } from '../../../../policyUI/classes/PolicyTypeEnum';

export interface ILoanPolicyProps {
  isAmericanDigital: boolean;
  longFormPolicy?: IStandardDocumentVersionData;
  shortFormPolicy?: IStandardDocumentVersionData;
  longLabel: string;
  shortLabel: string;
}

export const LoanPolicy: React.FC<ILoanPolicyProps> = ({
  isAmericanDigital,
  longFormPolicy,
  shortFormPolicy,
  longLabel,
  shortLabel,
}) => {
  return (
    <>
      <Header3Text>Loan Policy</Header3Text>
      <GenericEditCreatePolicy
        policyType={PolicyTypeEnum.longForm}
        isAmericanDigital={isAmericanDigital}
        label={longLabel}
        policy={longFormPolicy}
      />
      <Separator />
      <GenericEditCreatePolicy
        policyType={PolicyTypeEnum.shortForm}
        isAmericanDigital={isAmericanDigital}
        label={shortLabel}
        policy={shortFormPolicy}
      />
    </>
  );
};
